var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductionOrderStepEmbeddable',{attrs:{"path-order":"custom/production/order"},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})}
var staticRenderFns = []

export { render, staticRenderFns }